import { useState } from 'react';
import { useEnsNftContract, useZoomContract } from './useContract';
import { zoomFetchTokenUris } from '../utils';
import useAppCtx from './useAppCtx';
import useWeb3Ctx from './useWeb3Ctx';

const useEnsTokens = () => {
  const { address } = useWeb3Ctx();
  const { setMetadata, setMetadataLoaded, loading, setLoading } = useAppCtx();

  const ensContract = useEnsNftContract();
  const zoomContract = useZoomContract();

  const getTokens = async () => {
    setLoading(true);
    const tokens = await zoomFetchTokenUris(ensContract, zoomContract, address);
    if (tokens) {
      setMetadata(tokens);
      setMetadataLoaded(true);
    } else {
      setMetadata([]);
    }
    setLoading(false);
  };

  return { getTokens };
};

export default useEnsTokens;
